<template>
  <div class="work">
    <div class="work_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">不通过原因</div>
    </div>
    <div class="work_bottom">{{ cause }}</div>
  </div>
</template>

<script>
export default {
  name: "work",
  data() {
    return {
      cause: "",
    };
  },
  created() {
    this.cause = this.$route.query.cause
  },
  mounted() {},
  methods: {
    to() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.work {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .work_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    align-content: center;
    position: relative;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }

  .work_bottom {
    width: 94%;
    margin: 12px auto;
    border-radius: 8px;

    .van-field {
      border-radius: 8px;
    }
  }
}
</style>
